
import Button from '@/components/base/Button';

export default function PricingPlans() {
  const plans = [
    {
      name: 'Starter Funnel',
      price: '$497',
      period: 'one-time',
      description: 'Perfect for small businesses getting started with their first funnel',
      features: [
        '3-page funnel design',
        'Mobile responsive',
        'Basic integrations',
        'Email sequence setup',
        '2 weeks delivery',
        '3 revisions included',
        'Basic analytics setup'
      ],
      popular: false,
      cta: 'Get Started'
    },
    {
      name: 'Professional',
      price: '$997',
      period: 'one-time',
      description: 'Most popular choice for growing businesses that need comprehensive funnels',
      features: [
        '5-page funnel design',
        'Advanced integrations',
        'A/B testing setup',
        'Email automation',
        'Thank you pages',
        '1 week delivery',
        'Unlimited revisions',
        'Conversion optimization',
        'Analytics dashboard'
      ],
      popular: true,
      cta: 'Choose Professional'
    },
    {
      name: 'Enterprise',
      price: '$1,997',
      period: 'one-time',
      description: 'Complete funnel ecosystem for established businesses seeking maximum ROI',
      features: [
        'Multi-funnel system',
        'Custom integrations',
        'Advanced automation',
        'CRM setup',
        'Lead scoring system',
        '5 days delivery',
        'Unlimited revisions',
        'Dedicated account manager',
        'Monthly optimization',
        'Training & support'
      ],
      popular: false,
      cta: 'Go Enterprise'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Choose Your Perfect Plan
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            All plans include everything you need to start converting visitors into customers
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden ${
                plan.popular ? 'ring-2 ring-blue-600 transform scale-105' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <span className="bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-600 mb-6">{plan.description}</p>
                
                <div className="mb-8">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-600 ml-2">{plan.period}</span>
                </div>

                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  variant={plan.popular ? 'primary' : 'secondary'}
                  size="lg"
                  className="w-full whitespace-nowrap"
                >
                  {plan.cta}
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Need Something Custom?</h3>
            <p className="text-gray-600 mb-6">
              Looking for a custom solution? We create tailored funnel strategies for unique business needs.
            </p>
            <Button variant="outline" size="lg" className="whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>
              Schedule a Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}